import { render } from "./MySelect.vue?vue&type=template&id=0a9984ba&scoped=true"
import script from "./MySelect.vue?vue&type=script&lang=js"
export * from "./MySelect.vue?vue&type=script&lang=js"

import "./MySelect.vue?vue&type=style&index=0&id=0a9984ba&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9984ba"]])

export default __exports__